import React from 'react'

export const ReactorFormContext = React.createContext({
  fieldMap: {}
})
